module.exports = __webpack_public_path__ + "img/device-pile.c2d16687.png";